export default __webpack_public_path__ + "static/media/zucchero10.a45e0f03.webp";